// extracted by mini-css-extract-plugin
export default {"wrap":"GI-z","subtitle":"HI-z","contentWrap":"II-z","imgWrap":"JI-z","heading":"KI-z","copy":"LI-z"};